import { forwardRef } from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";
import { useResolvedTheme, radiusScale } from "@xsolla/xui-core";
import type {
  ProgressLineProps,
  ProgressLineSize,
  ProgressLineState,
} from "./types";

const getHeight = (size: ProgressLineSize) => {
  switch (size) {
    case "sm":
      return 4;
    case "md":
      return 6;
    case "lg":
      return 8;
    default:
      return 6;
  }
};

const getStateColor = (state: ProgressLineState, theme: any) => {
  switch (state) {
    case "success":
      return theme.colors.background.success.primary;
    case "error":
      return theme.colors.background.alert.primary;
    default:
      return theme.colors.background.brand.primary;
  }
};

export const ProgressLine = forwardRef<any, ProgressLineProps>(
  (
    {
      size = "md",
      state = "default",
      percent = 0,
      testID,
      themeMode,
      themeProductContext,
      ...rest
    },
    ref
  ) => {
    const { theme } = useResolvedTheme({ themeMode, themeProductContext });
    const validPercent = Math.min(Math.max(0, percent), 100);
    const height = getHeight(size);
    const innerColor = getStateColor(state, theme);

    return (
      <Box
        {...rest}
        ref={ref}
        width="100%"
        height={height}
        backgroundColor={theme.colors.control.faint.bg}
        borderRadius={radiusScale["999"]}
        overflow="hidden"
        testID={testID || "progress-line__outer"}
        role="progressbar"
        aria-valuenow={validPercent}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <Box
          height="100%"
          width={`${validPercent}%`}
          backgroundColor={innerColor}
          borderRadius={radiusScale["999"]}
          data-testid="progress-line__inner"
          style={{ transition: "width 300ms ease" }}
        />
      </Box>
    );
  }
);

ProgressLine.displayName = "ProgressLine";
